import React, { useState, useEffect } from 'react';
import { API, authHeaders } from '../services/config';
import './PrestacionesModal.css';

export default function PrestacionesModal({ pacienteId, pacienteNombre, isOpen, onClose, onPrestacionAgregada }) {
  const [practicas, setPracticas] = useState([]);
  const [form, setForm] = useState({
    practica_id: '',
    cantidad: 1,
    costo: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [profesionalId, setProfesionalId] = useState(null);

  useEffect(() => {
    if (isOpen) {
      fetchPracticas();
    }
  }, [isOpen]);

  const fetchPracticas = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API}/practicas`, { headers: authHeaders() });
      const data = await res.json();
      if (data.success) {
        setPracticas(data.data);
      }
      setError(null);
    } catch (err) {
      setError('Error al cargar prácticas');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: name === 'cantidad' ? parseInt(value) || 1 : value
    }));
  };

  const handleSelectPractica = (practica) => {
    setForm(prev => ({
      ...prev,
      practica_id: practica.id,
      costo: practica.costo_base || ''
    }));
  };

  const handleGuardar = async () => {
    if (!form.practica_id || !form.costo) {
      setError('Completa todos los campos requeridos');
      return;
    }

    try {
      setLoading(true);
      const practicaSeleccionada = practicas.find(p => p.id == form.practica_id);
      
      const res = await fetch(`${API}/pacientes/${pacienteId}/prestaciones`, {
        method: 'POST',
        headers: {
          ...authHeaders(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          practica_id: form.practica_id,
          fecha: new Date().toISOString().split('T')[0],
          prestacion: practicaSeleccionada?.nombre || 'Prestación',
          costo: parseFloat(form.costo),
          cantidad: form.cantidad,
          abonado: false
        })
      });

      const result = await res.json();

      if (result.success) {
        // Resetear formulario
        setForm({
          practica_id: '',
          cantidad: 1,
          costo: ''
        });
        setError(null);
        
        // Llamar callback para actualizar la lista
        if (onPrestacionAgregada) {
          onPrestacionAgregada(result.data);
        }
        
        // Cerrar después de 1 segundo
        setTimeout(() => {
          onClose();
        }, 1000);
      } else {
        setError(result.message || 'Error al guardar la prestación');
      }
    } catch (err) {
      setError('Error al guardar la prestación');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-prestaciones" onClick={onClose}>
      <div className="modal-content-prestaciones" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-prestaciones">
          <h4>➕ Agregar Prestación</h4>
          <button className="btn-close-prestaciones" onClick={onClose}>✕</button>
        </div>

        {error && <div className="error-message-prestaciones">{error}</div>}

        <div className="modal-body-prestaciones">
          <div className="paciente-info-prestaciones">
            <p className="paciente-label">Paciente:</p>
            <p className="paciente-nombre">{pacienteNombre}</p>
          </div>

          <div className="form-group-prestaciones">
            <label>Seleccionar Práctica *</label>
            {loading && !practicas.length ? (
              <div className="loading-practicas">Cargando prácticas...</div>
            ) : (
              <div className="practicas-grid-modal">
                {practicas.map(practica => (
                  <div
                    key={practica.id}
                    className={`practica-option ${form.practica_id == practica.id ? 'selected' : ''}`}
                    onClick={() => handleSelectPractica(practica)}
                  >
                    <div className="practica-option-name">{practica.nombre}</div>
                    {practica.costo_base && (
                      <div className="practica-option-cost">
                        ${practica.costo_base}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {form.practica_id && (
            <>
              <div className="form-group-prestaciones">
                <label>Cantidad *</label>
                <input
                  type="number"
                  name="cantidad"
                  min="1"
                  value={form.cantidad}
                  onChange={handleChange}
                  className="input-field-prestaciones"
                />
              </div>

              <div className="form-group-prestaciones">
                <label>Costo Total *</label>
                <div className="input-costo-wrapper">
                  <input
                    type="number"
                    name="costo"
                    step="0.01"
                    value={form.costo}
                    onChange={handleChange}
                    className="input-field-prestaciones"
                    placeholder="0.00"
                  />
                  <span className="costo-unitario">
                    (Unitario: ${(form.costo / form.cantidad).toFixed(2)})
                  </span>
                </div>
              </div>

              <div className="resumen-prestacion">
                <div className="resumen-row">
                  <span>Práctica:</span>
                  <strong>{practicas.find(p => p.id == form.practica_id)?.nombre}</strong>
                </div>
                <div className="resumen-row">
                  <span>Cantidad:</span>
                  <strong>{form.cantidad}</strong>
                </div>
                <div className="resumen-row total">
                  <span>Total:</span>
                  <strong className="total-valor">${form.costo ? parseFloat(form.costo).toFixed(2) : '0.00'}</strong>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="modal-footer-prestaciones">
          <button
            className="btn-cancel-prestaciones"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            className="btn-save-prestaciones"
            onClick={handleGuardar}
            disabled={loading || !form.practica_id || !form.costo}
          >
            {loading ? 'Guardando...' : 'Guardar Prestación'}
          </button>
        </div>
      </div>
    </div>
  );
}
